import React, { FC } from 'react';
import classnames from 'classnames';

import { IDynamicComponent } from 'plugins/api/types';

import { DynamicSwitchComponent } from 'plugins/components/containers';

import 'plugins/theme/components/ListPanel/ListPanel.scss';

// typ danych wejściowych
interface IProps {
  pageSymbol: string;
  components?: IDynamicComponent[];
  requestParams?: object;
  horizontal?: boolean;
}

const ListPanel: FC<IProps> = ({ pageSymbol, components, requestParams, horizontal }) => {
  return (
    <div className={classnames('ListPanel', horizontal && 'ListPanel-Horizontal')}>
      <DynamicSwitchComponent
        components={components}
        pageSymbol={pageSymbol}
        requestParams={requestParams}
        horizontal={horizontal}
      />
    </div>
  );
};

export default ListPanel;
